module.exports = __webpack_public_path__ + "img/edv_it.e0cf247.svg";